export enum CashRegisterPageKey {
  UNSETTLED = 'unsettled',
  SETTLED = 'usettled',
  REPORTS = 'reports',
}
